import React from "react";
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { DropDownButton, DropDownButtonItem } from "@progress/kendo-react-buttons";
import { FacilityOrderTemplateNewFlowCustomOrderingDoctorChangeModal } from "application/facility-order-new-flow/components";
import { BaasicModal } from "core/components";

function FacilityOrderTemplateNewFlowCustomOrderingDoctorAddTemplate({ facilityOrderTemplateNewFlowCustomOrderingDoctorAddViewStore }) {
    const {
        facilityOrderTemplate,
        updateCustomOrderingDoctorData,
        facilityOrderTemplateNewFlowCustomOrderingDoctorChangeModal,
        openFacilityOrderTemplateNewFlowCustomOrderingDoctorChangeModal,
        isClinicalInfoModal
    } = facilityOrderTemplateNewFlowCustomOrderingDoctorAddViewStore;

    const handleDropDownItemsOnClick = async (e) => {
        if (e.item.text === "Change Doctor") {
            updateCustomOrderingDoctorData("change-doctor");
        }
        else if (e.item.text === "Remove Doctor") {
            updateCustomOrderingDoctorData("remove-doctor");
        }
    }

    return (
        <React.Fragment>
            <DropDownButton
                fillMode={"solid"}
                themeColor={"primary"}
                onItemClick={(e) => handleDropDownItemsOnClick(e)}
                buttonClass={`btn btn--sml btn--light btn--dd doctor ${facilityOrderTemplate.customOrderingDoctorId || facilityOrderTemplate.isOrderingDoctorRemoved ? 'has-triangle' : ''}`}
                popupSettings={!isClinicalInfoModal ? {
                    animate: false,
                    anchorAlign: { horizontal: "right", vertical: "bottom" },
                    popupAlign: { horizontal: "right", vertical: "top" }
                } : {}}
                itemRender={(props) => {
                    const { item } = props;
                    if (item.text === "Change Doctor") {
                        return (
                            <div className="u-flex--default">
                                <button
                                    onClick={() => updateCustomOrderingDoctorData("change-doctor")}
                                    className="dd-button u-mar--right--sml"
                                >
                                    <span className="u-icon u-icon--change2--grey u-icon--sml" />
                                </button>
                                <span className="item-text">{item.text}</span>
                            </div>
                        );
                            
                    }
                    if (item.text === "Doctor Changed") {
                        return (
                            <div className="u-flex--default"
                                onClick={() => openFacilityOrderTemplateNewFlowCustomOrderingDoctorChangeModal()}
                            >
                                <button
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        updateCustomOrderingDoctorData("undo-change-doctor");
                                    }}
                                    className="dd-button is-undo u-mar--right--sml"
                                >
                                    <span className="u-icon u-icon--xmed u-icon--undo--grey" />
                                </button>
                                <span className="item-text">{item.text}</span>
                            </div>
                        );
                    } else if (item.text === "Remove Doctor") {
                        return (
                            <div className="u-flex--default">
                                <React.Fragment>
                                    <div className="u-icon u-icon--xmed u-icon--delete--grey"  style={{ marginRight: '7px', paddingLeft: '4px' }}/>
                                </React.Fragment>
                                <span className="item-text">{item.text}</span>
                            </div>
                        );
                    }
                    else if (item.text === "Doctor Removed") {
                        return (
                            <div className="u-flex--default">
                                <button
                                    onClick={() => updateCustomOrderingDoctorData("undo-remove-doctor")}
                                    className="dd-button is-undo u-mar--right--sml"
                                >
                                    <span className="u-icon u-icon--xmed u-icon--undo--grey" />
                                </button>
                                <span className="item-text" style={{cursor: 'default'}}>{item.text}</span>
                            </div>
                        );
                    }

                    return <span>{item.text}</span>;
                }}
            >
                {!facilityOrderTemplate.customOrderingDoctorId && !facilityOrderTemplate.isOrderingDoctorRemoved && (
                    <DropDownButtonItem iconClass="u-icon u-icon--xmed u-icon--danger" text="Change Doctor" />
                )}

                {facilityOrderTemplate.customOrderingDoctorId && !facilityOrderTemplate.isOrderingDoctorRemoved && (
                    <DropDownButtonItem iconClass="u-icon u-icon--xmed u-icon--danger" text="Doctor Changed" />
                )}

                {!facilityOrderTemplate.isOrderingDoctorRemoved && (
                    <DropDownButtonItem iconClass="u-icon u-icon--xmed u-icon--danger" text="Remove Doctor" />
                )}

                {facilityOrderTemplate.isOrderingDoctorRemoved && (
                    <DropDownButtonItem iconClass="u-icon u-icon--xmed u-icon--danger" text="Doctor Removed" />
                )}

            </DropDownButton>
            <BaasicModal modalParams={facilityOrderTemplateNewFlowCustomOrderingDoctorChangeModal} className="modal__content modal--med">
                <FacilityOrderTemplateNewFlowCustomOrderingDoctorChangeModal />
            </BaasicModal>
        </React.Fragment>
    )
}

FacilityOrderTemplateNewFlowCustomOrderingDoctorAddTemplate.propTypes = {
    facilityOrderTemplateNewFlowCustomOrderingDoctorAddViewStore: PropTypes.object,
    item: PropTypes.object,
};

export default defaultTemplate(FacilityOrderTemplateNewFlowCustomOrderingDoctorAddTemplate);